import { render, staticRenderFns } from "./User_Confirmation.vue?vue&type=template&id=45b01dd4&scoped=true&"
import script from "./User_Confirmation.vue?vue&type=script&lang=js&"
export * from "./User_Confirmation.vue?vue&type=script&lang=js&"
import style0 from "./User_Confirmation.vue?vue&type=style&index=0&id=45b01dd4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b01dd4",
  null
  
)

export default component.exports